//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/activities/views/main/lan/en';
import tab from 'Modules/activities/.components/tab/lan/en';
import changeDetails from 'Modules/activities/.components/changeDetails/lan/en';

locales = { ...locales, ...main, ...tab, ...changeDetails };


export default locales;